import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext({
  user: {},
  setUser: user => {},
  existingPages: [],
  setExistingPages: pages => {},
  currentPosts: null,
  setCurrentPosts: posts => {},
  positiveComments: 0,
  setPositiveComments: count => {},
  negativeComments: 0,
  setNegativeComments: count => {},
  neutralComments: 0,
  setNeutralComments: count => {},
  totalVideoCount: 0,
  videoPageNum: 1,
  setTotalVideoCount: count => {},
  setVideoPageNum: num => {},
  walletAddress: '',
  setWalletAddress: address => {},
});

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState<object>({});
  const [existingPages, setExistingPages] = useState([]);
  const [currentPosts, setCurrentPosts] = useState<null | any[]>(null);
  const [positiveComments, setPositiveComments] = useState<number>(0);
  const [negativeComments, setNegativeComments] = useState<number>(0);
  const [neutralComments, setNeutralComments] = useState<number>(0);
  const [totalVideoCount, setTotalVideoCount] = useState<number>(0);
  const [videoPageNum, setVideoPageNum] = useState<number>(1);
  const [walletAddress, setWalletAddress] = useState<string>('');

  const value: {
    user: object;
    setUser: any;
    existingPages: any;
    setExistingPages: any;
    currentPosts: any;
    setCurrentPosts: any;
    positiveComments: number;
    setPositiveComments: any;
    negativeComments: number;
    setNegativeComments: any;
    neutralComments: number;
    setNeutralComments: any;
    totalVideoCount: any;
    setTotalVideoCount: any;
    videoPageNum: any;
    setVideoPageNum: any;
    walletAddress: any;
    setWalletAddress: any;
  } = {
    user,
    setUser,
    existingPages,
    setExistingPages,
    currentPosts,
    setCurrentPosts,
    positiveComments,
    setPositiveComments,
    negativeComments,
    setNegativeComments,
    neutralComments,
    setNeutralComments,
    totalVideoCount,
    setTotalVideoCount,
    videoPageNum,
    setVideoPageNum,
    walletAddress,
    setWalletAddress,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUserContext = () => useContext(UserContext);
